import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = "";
        if (error?.error?.message){
            errorMsg = error.error.message;
        } else if (error?.error?.error_description){
            errorMsg = error.error.error_description;
        } else if (error?.error?.error){
          errorMsg = error.error.error;
        } else if (error?.message){
          errorMsg = error.message;
        }
        if (errorMsg != 'Authorization token expired' && 
            errorMsg != 'No Authorization was found in request.headers' &&
            !req.url.includes('logout') &&
            !req.url.includes('refresh-token')) {
          console.log(errorMsg);
          this.notificationService.showError(errorMsg);
        }
        throw error;
      })
    );
  }
}